import { env } from '@/main/config'
import { makeRecoverSession } from '@/main/factories/modules/auth/make-recover-session'
import { SupabaseEdgeHttpClient } from '@/shared/infra/http'
import { makeSupabaseClient } from '@/shared/infra/supabase'

let cached: SupabaseEdgeHttpClient | null = null
let tokenOverride: string | null = null

export function setTokenOverride(token: string): void {
  tokenOverride = token
}

export function clearTokenOverride(): void {
  tokenOverride = null
}

export function makeSupabaseEdgeHttpClient(): SupabaseEdgeHttpClient {
  if (cached) return cached
  const supabase = makeSupabaseClient()
  const recoverSession = makeRecoverSession()
  cached = new SupabaseEdgeHttpClient(
    env.edgeFunctionsBaseUrl,
    async () => {
      if (tokenOverride) return tokenOverride
      const { data: { session } } = await supabase.auth.getSession()
      return session?.access_token ?? null
    },
    async () => (tokenOverride ? tokenOverride : recoverSession()),
  )
  return cached
}
